import { oz } from '@weft/utils';
import { BrearerTokenDataSchema } from './bearer';

export const IntegrationDataSchema = oz.discriminatedUnion('integrationType', [
  BrearerTokenDataSchema,
]);

export type IntegrationData = oz.infer<typeof IntegrationDataSchema>;